var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimerClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.36 10.64c.507.47.507 1.29 0 1.758a1.212 1.212 0 01-.86.352c-.352 0-.664-.117-.898-.352L6.5 8.297l-4.14 4.101a1.212 1.212 0 01-.86.352c-.352 0-.664-.117-.898-.352a1.205 1.205 0 010-1.757L4.703 6.5.602 2.398a1.205 1.205 0 010-1.757 1.205 1.205 0 011.757 0L6.5 4.742 10.602.641a1.205 1.205 0 011.757 0c.508.468.508 1.289 0 1.757L8.258 6.54l4.101 4.102z",
    fill: "#000"
  })));
}

export default SvgTimerClose;